import Cookies from 'js-cookie';
export default class HeaderController {
	constructor(autoinit = true) {
		this.headerElement = null;
		this.menuButton = null;

		this.previousScroll = 0;
		this.scrollCounter = 0;
		this.threshold = 500;

		this.init();
		this.resize();

		this.threshold = .2;
		this.initCreateObserver();
	}

	init() {
		this.headerElement = document.querySelector('header');
		this.menuButton = this.headerElement.querySelector('.menuButton');
		this.previousScroll = window.pageYOffset;

		this.initHighContrast();

		// Register events
		window.app.registerResizeEvent(this.resize.bind(this));
		window.app.registerScrollEvent(this.scroll.bind(this));

		// Click events
		this.menuButton.addEventListener('click', this.toggleMenu.bind(this));

		this.configurePatientportalTooltip();

		document.addEventListener('keydown', e => {
			if (e.key.toLowerCase().substr(0, 3) == 'esc' && this.headerElement.classList.contains('menuActive')) {
				this.toggleMenu();
			}
		});

		if (this.headerElement.classList.contains('menuActive')) {
			this.openMenu();
		} else {
			this.closeMenu();
		}
	}

	toggleMenu() {
		if (this.headerElement.classList.contains('menuActive')) {
			this.closeMenu();
		} else {
			this.openMenu();
		}
	}

	openMenu() {
		this.headerElement.classList.add('menuActive');
		document.documentElement.classList.add('disableScroll');

		if (this.headerElement.querySelector('.navigationPanel')) {
			this.headerElement.querySelector('.navigationPanel').setAttribute('aria-hidden', false);

			// Enable all clickables
			this.headerElement.querySelector('.navigationPanel').querySelectorAll('a, button').forEach(clickable => {
				clickable.setAttribute('tabindex', 0);
			});
		}

		if (this.menuButton) {
			this.menuButton.setAttribute('aria-expanded', true);
			this.menuButton.querySelector('span').setAttribute('aria-hidden', false);
		}
	}

	closeMenu() {
		this.headerElement.classList.remove('menuActive')
		document.documentElement.classList.remove('disableScroll');

		if (this.headerElement.querySelector('.navigationPanel')) {
			this.headerElement.querySelector('.navigationPanel').setAttribute('aria-hidden', true);

			// Disable all clickables
			this.headerElement.querySelector('.navigationPanel').querySelectorAll('a, button').forEach(clickable => {
				clickable.setAttribute('tabindex', -1);
			});
		}

		if (this.menuButton) {
			this.menuButton.setAttribute('aria-expanded', false);
			this.menuButton.querySelector('span').setAttribute('aria-hidden', true);
		}
	}

	resize() {
		this.previousScroll = window.pageYOffset;
		this.threshold = this.headerElement.clientHeight;

		this.scroll();
	}

	scroll() {
		// First, decide if it's up or down
		if (window.pageYOffset > this.headerElement.clientHeight) {
			this.headerElement.classList.add('minifyLogo');
		} else {
			this.headerElement.classList.remove('minifyLogo');
		}
	}

	initHighContrast() {
		if (this.headerElement.querySelector('.contrastButton')) {
			this.contrastButton = this.headerElement.querySelector('.contrastButton');

			if (Cookies.getJSON('highContrast') !== null && Cookies.getJSON('highContrast')) {
				this.enableHighContrast();
			}

			if (!window.CSS || !window.CSS.supports || !window.CSS.supports('color', 'var(--test)')) {
				this.enableHighContrast();
			}

			this.contrastButton.addEventListener('click', this.toggleHighContrast.bind(this));
		}
	}

	toggleHighContrast() {
		if (document.documentElement.classList.contains('highContrast')) {
			this.disableHighContrast();

			Cookies.set('highContrast', false, {
				expires: 7,
			});
		} else {
			this.enableHighContrast();

			Cookies.set('highContrast', true, {
				expires: 7,
			});
		}
	}

	enableHighContrast() {
		document.documentElement.classList.add('highContrast');
	}

	disableHighContrast() {
		document.documentElement.classList.remove('highContrast');
	}

	hide() {
		this.headerElement.classList.add('hidden');
	}

	show() {
		this.headerElement.classList.remove('hidden');
	}

	//cta observer
	initCreateObserver() {
		var heroInView = false;
		var formInView = false;
		var footerInView = false;

		//check if hero of form is in view on scroll
		if (document.querySelectorAll('.ctaButtonTrigger').length) {
			window.addEventListener('scroll', (e) => {
				if (heroInView || formInView || footerInView) {
					document.querySelector(".callToActionContainer").classList.remove('show');
				} else {
					document.querySelector(".callToActionContainer").classList.add('show');
				};
			})
		};

		//for toggling button when hero is in view
		if (document.querySelectorAll('.ctaButtonTrigger').length) {
			let boxElement;

			window.addEventListener("load", (event) => {
				boxElement = document.querySelector(".ctaButtonTrigger");

				createObserver();
			}, false);

			function createObserver() {
				let observer;

				let options = {
					root: null,
					rootMargin: "0px",
					threshold: 0,
				};

				observer = new IntersectionObserver(handleIntersect, options);
				observer.observe(boxElement);
			}

			function handleIntersect(entries, observer) {
				entries.forEach((entry) => {
					if (entry.intersectionRatio > 0) {
						heroInView = true;
						// console.log('heroInView is true');
					} else {
						heroInView = false;
						// console.log('heroInView is false');
					}

				});
			}
		}

		//for toggling button when form is in view
		if (document.querySelectorAll('.ctaButtonTriggerForm').length) {
			let boxElement;

			window.addEventListener("load", (event) => {
				boxElement = document.querySelector(".ctaButtonTriggerForm");

				createObserver();
			}, false);

			function createObserver() {
				let observer;

				let options = {
					root: null,
					rootMargin: "0px",
					threshold: 0,
				};

				observer = new IntersectionObserver(handleIntersect, options);
				observer.observe(boxElement);
			}

			function handleIntersect(entries, observer) {
				entries.forEach((entry) => {
					if (entry.intersectionRatio > 0) {
						formInView = true;
						// console.log('formInView is true');
					} else {
						formInView = false;
						// console.log('formInView is false');
					}
				});
			}
		}

		//for toggling button when foooter is in view
		if (document.querySelectorAll('.ctaButtonFooterTrigger').length) {
			let boxElement;

			window.addEventListener("load", (event) => {
				boxElement = document.querySelector(".ctaButtonFooterTrigger");

				createObserver();
			}, false);

			function createObserver() {
				let observer;

				let options = {
					root: null,
					rootMargin: "0px",
					threshold: 0,
				};

				observer = new IntersectionObserver(handleIntersect, options);
				observer.observe(boxElement);
			}

			function handleIntersect(entries, observer) {
				entries.forEach((entry) => {
					if (entry.intersectionRatio > 0) {
						formInView = true;
						// console.log('formInView is true');
					} else {
						formInView = false;
						// console.log('formInView is false');
					}
				});
			}
		}
	}

	configurePatientportalTooltip() {
		if (this.headerElement.querySelector('a.patientPortal')) {
			const tooltipContainer = this.headerElement.querySelector('a.patientPortal + .tooltipcontainer');

			if (tooltipContainer) {
				// Check if user already closed the popup. If not, show it
				if (Cookies.getJSON('patientportalTooltip') === undefined) {
					setTimeout(() => {
						tooltipContainer.classList.remove('d-none');
					}, 500);

					// Add eventlistener to disable the tooltip
					tooltipContainer.querySelector('button').addEventListener('click', () => {
						tooltipContainer.classList.add('removing');
						Cookies.set('patientportalTooltip', true, {
							expires: 365,
						});

						setTimeout(() => {
							tooltipContainer.classList.add('d-none');
						}, 500);
					});
				}
			}
		}
	}

}